import { render, staticRenderFns } from "./EditUserInformation.vue?vue&type=template&id=fbae3ce2&"
import script from "./EditUserInformation.vue?vue&type=script&lang=js&"
export * from "./EditUserInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports